export default __webpack_public_path__ + "static/media/jasperactive_create_adobe.bfa8a0c7.svg";